import { render, staticRenderFns } from "./ClientOnboarding.vue?vue&type=template&id=3da65a98&"
import script from "./ClientOnboarding.vue?vue&type=script&lang=js&"
export * from "./ClientOnboarding.vue?vue&type=script&lang=js&"
import style0 from "./ClientOnboarding.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../front.sfc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports